<template>
  <div class="text">

    <div class="top">
      <back-button />
      <help-button v-if="showhelp" />
      <!-- <help-button /> -->
    </div>

    <div class="content">
      <h1 class="logo">{{ title }}</h1>
        <div class="textbox" v-html="text"></div>
        <div class="controls">
          <button @click="$router.go(-1)">Back</button>
        </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'text',
  props: {
    title: String,
    text: String,
    showhelp: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
// .fade-enter-active, .fade-leave-active {
//   transition: opacity 5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
.text {
  color: #000;
  height: 100%;
  overflow: hidden;
  background: url('../assets/backgrounds/help-bg.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}


.top {
  display: flex;

  padding: 10px;
  // hack as flex is collapsing on iosx safari ;(
  flex-basis: 58px;

  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .back-button{
    flex-basis:auto;
  }
}
.content {
  color: #000;
  background-color: white;
  padding: 20px;
  margin: 30px;
  margin-top: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  .logo {
    flex: 0;
  }
  p, div{
    flex: 1;
  }
  div.controls {
    flex: 0;
  }
}
</style>
